export default __webpack_public_path__ + "static/media/estante_01.ca99a751.png";